import { render } from "./edit_carriage.vue?vue&type=template&id=0e15887d&scoped=true"
import script from "./edit_carriage.vue?vue&type=script&lang=js"
export * from "./edit_carriage.vue?vue&type=script&lang=js"

import "./edit_carriage.vue?vue&type=style&index=0&id=0e15887d&scoped=true&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_pms_web\\pms_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e15887d"]])

export default __exports__